export default "__VITE_ASSET__t7yGNzXI__"